export enum Websockets$SendMessageType { "UserNotification" = "UserNotification"};

export enum Websockets$UserNotificationType { "EnduserMadeInquiryOnAsset" = "EnduserMadeInquiryOnAsset" , "EnduserRegisteredProductOnAsset" = "EnduserRegisteredProductOnAsset" , "EnduserRequestsAssetVideoCall" = "EnduserRequestsAssetVideoCall" , "EnduserStartedAssetAiConversation" = "EnduserStartedAssetAiConversation"};

export interface Websockets$UserNotification {
    type: Websockets$UserNotificationType;
}